// extracted by mini-css-extract-plugin
export default {"page-select-input":"style_page-select-input__QwiUh","page-select-input-dropdown":"style_page-select-input-dropdown__boX1m"};